'use client'

import { useEffect } from 'react'
import { FaClock, FaMapMarkerAlt, FaPhone } from 'react-icons/fa'

import '@/styles/components/_addressInfo.scss'

//__INTERFACE
interface AddressInfoData {
  address: string
  mapUrl: string
  openHours: string
  closeHours: string
  phoneNumber: string
}

interface AddressInfoProps {
  data: AddressInfoData
}

export default function AddressInfo({ data }: AddressInfoProps) {
  //__RENDER
  return (
    <div className='address-info'>
      <a
        href={data.mapUrl}
        className='address-info-container'
        target='_blank'
        rel='noopener noreferrer'>
        <i className='address-info-icon'>
          <FaMapMarkerAlt />
        </i>
        {data.address}
      </a>
      <span className='address-info-container'>
        <i className='address-info-icon'>
          <FaClock />
        </i>
        Open Dialy:&nbsp;{data.openHours} - {data.closeHours}
      </span>
      <a href={`tel:${data.phoneNumber}`} className='address-info-container'>
        <i className='address-info-icon'>
          <FaPhone />
        </i>
        RSVN (8:30-21:30 daily):&nbsp;
        <span className='phone-number-text'>{data.phoneNumber}</span>
      </a>
    </div>
  )
}
